export const columns = ({ t }) => [
  {
    title: t('Last Name'),
    name: 'lastName'
  },
  {
    title: t('First Name'),
    name: 'firstName'
  },
  {
    title: t('Phone Number'),
    name: 'phone'
  },
  {
    title: t('Email Address'),
    name: 'email'
  },
  {
    title: t('Status'),
    name: 'status'
  }
];

export const formatData = (contacts, t) =>
  contacts.map(contact => ({
    id: contact.id,
    firstName: contact.firstName,
    lastName: contact.lastName,
    phone: contact.phone,
    email: contact.email,
    active: contact.active,
    status: contact.active ? t('Active') : t('Inactive'),
    rowVersion: String(contact.rowVersion)
  }));

export default {
  columns,
  formatData
};
